<form [formGroup]="formulario" fxLayout="column" fxFill (ngSubmit)="onSubmit()">

  <div class="ps-identity-container">
    <div fxLayout="row" >
      <h2 class="ps-title-large ps-title-margin">Configure os campos de integração</h2>
    </div>
      <div fxLayout="row" class="ps-row" fxLayoutGap="23px" fxLayout.sm="column" fxLayout.xs="column">
        <div fxLayout="column" fxFlex>
          <mat-form-field appearance="fill" fxFlex>
            <mat-label>Tipo do campo</mat-label>
            <mat-select formControlName="fieldType">
              <mat-option *ngFor="let type of fieldTypes index as i" [value]="type">
                {{type.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.tabelaTotvs.hasError('required')">
              Campo obrigatório
            </mat-error>
          </mat-form-field>
        </div>

        <div fxLayout="column" fxFlex>
          <mat-label [ngClass]="{disabled: this.f.ps_table.disabled}">Tabela do processo seletivo</mat-label>
          <mat-radio-group fxFlex formControlName="ps_table" color="primary" fxLayoutAlign="start center">
            <mat-radio-button [value]="false" style="margin-right: 20px;">Pessoa</mat-radio-button>
            <mat-radio-button [value]="true">Inscrição</mat-radio-button>
          </mat-radio-group>
        </div>

        <div fxLayout="column" fxFlex [ngClass]="{disabled:  formulario.get('fieldType').value?.id == 7}">
          <mat-label [ngClass]="{disabled: this.f.multivalue.disabled}">Multivalorado</mat-label>
          <mat-radio-group fxFlex formControlName="multivalue" color="primary" fxLayoutAlign="start center">
            <mat-radio-button [value]="false" style="margin-right: 20px;">Não</mat-radio-button>
            <mat-radio-button [value]="true" [disabled]="formulario.get('fieldType').value?.id == 7">Sim</mat-radio-button>
          </mat-radio-group>
        </div>

      </div>
  </div>

  <div fxLayout="row">
    <div fxFlex>
      <mat-divider></mat-divider>
    </div>
  </div>

  <div class="ps-identity-container" style="padding-top: 13px;">
    <div fxLayout="column" style="padding-bottom: 15px;">
      <span style="color: #808080; padding-bottom: 10px;">Integração Rubeus</span>
      <mat-slide-toggle style="width: 135px;" color="primary" formControlName="integracaoRubeus">
        {{formulario.controls.integracaoRubeus.value === true ? 'Ativada' : 'Desativada'}}
      </mat-slide-toggle>
    </div>

    <div [ngClass]="{'hideRubeusFields': hideRubeusFields}">
      <div fxLayout="row" class="ps-row" fxLayoutGap="23px" fxLayout.sm="column" fxLayout.xs="column">

        <div fxLayout="column" fxFlex>
          <mat-label [ngClass]="{disabled: this.f.tabelaRubeus.disabled}">Tabela Rubeus</mat-label>
          <mat-radio-group (change)="onColumnRubeusChanged($event)"  fxFlex formControlName="tabelaRubeus" color="primary" fxLayoutAlign="start center" >
            <mat-radio-button [value]="false" style="margin-right: 20px;">Contato</mat-radio-button>
            <mat-radio-button [value]="true">Registro</mat-radio-button>
          </mat-radio-group>
        </div>

        <mat-form-field appearance="fill" fxFlex>
          <mat-label>Coluna Rubeus</mat-label>
          <input
            type="text"
            placeholder="Escolha uma coluna"
            aria-label="Texto"
            matInput
            formControlName="colunaRubeus"
            [matAutocomplete]="auto4"
            >
          <mat-autocomplete
            [displayWith]="getOptionText"
            autoActiveFirstOption
            #auto4="matAutocomplete">
            <mat-option  *ngFor="let option of filteredColumnRubeus | async" [value]="option">
              {{ option.name }}
            </mat-option>
          </mat-autocomplete>
          <mat-hint>Escolha uma coluna já existente referente à tabela selecionada</mat-hint>
          <mat-error *ngIf="f.colunaRubeus.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>
    </div>

  </div>

  <div fxLayout="row">
    <div fxFlex>
      <mat-divider></mat-divider>
    </div>
  </div>

  <div class="ps-identity-container" style="padding-top: 13px;">
    <div fxLayout="column" style="padding-bottom: 15px;">
      <span style="color: #808080; padding-bottom: 10px;">Integração TOTVS</span>
      <mat-slide-toggle style="width: 135px;" color="primary" formControlName="integracaoTotvs">
        {{formulario.controls.integracaoTotvs.value === true ? 'Ativada' : 'Desativada'}}
      </mat-slide-toggle>
    </div>
    <div [ngClass]="{'hideTotvsFields': hideTotvsFields}">
      <div fxLayout="row" class="ps-row" fxLayoutGap="23px" fxLayout.sm="column" fxLayout.xs="column">
        <mat-form-field appearance="fill" fxFlex fxFlex.gt-sm="100">
          <mat-label>Tabela do TOTVS</mat-label>
          <input
            type="text"
            placeholder="Escolha uma tabela"
            aria-label="Texto"
            matInput
            formControlName="tabelaTotvs"
            >
          <mat-hint>Escolha uma tabela já existente no TOTVS</mat-hint>
          <mat-error *ngIf="f.tabelaTotvs.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" fxFlex fxFlex.gt-sm="100">
          <mat-label>Campo TOTVS</mat-label>
          <input
            type="text"
            placeholder="Escolha uma coluna"
            aria-label="Texto"
            matInput
            id="colunaTotvs"
            formControlName="colunaTotvs"
            >
          <mat-hint>Escolha uma coluna já existente referente à tabela selecionada</mat-hint>
          <mat-error *ngIf="f.colunaTotvs.hasError('required')">
            Campo obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" fxFlex fxFlex.gt-sm="100">
          <mat-label>Nome alternativo</mat-label>
          <input
            type="text"
            placeholder="Nome do campo"
            aria-label="Texto"
            matInput
            id="nomeAlternativoTotvs"
            formControlName="nomeAlternativoTotvs"
            >
          <mat-hint>Seguindo padrão Oracle</mat-hint>
          <mat-error *ngIf="f.nomeAlternativoTotvs.hasError('maxlength')">
            O número máximo de caracteres é 30
          </mat-error>
          <mat-error *ngIf="f.nomeAlternativoTotvs.hasError('invalidCharacter')">
            Não pode haver ponto
          </mat-error>
         
        </mat-form-field>
      </div>
    </div>
  </div>

</form>
